import { useApolloClient } from '@apollo/client';
import { useEffect, useState } from 'react';

import { getSubmissionByExternalId, getSubmissionsByExternalId, parseAnswers } from '../../../services';

export const useAnswer = ({
  externalId,
  locale,
  allTitle,
  allIndex,
  groupByConfig,
  filterByQuestionGroupKeys,
  structureType,
  structuresConfig,
  handleError,
  category,
}: any) => {
  const [answers, setAnswers] = useState<any>();
  const [answersList, setAnswersList] = useState<any>();
  const [loading, setLoading] = useState<any>();
  const client = useApolloClient();

  const checkIfNotEmpty = (answers) => answers.some((answer) => answer.questionGroups?.length > 0);

  useEffect(() => {
    const init = async () => {
      setLoading(true);
      if (structuresConfig) {
        const submissions = await getSubmissionsByExternalId(
          externalId,
          structuresConfig?.map((config) => config.type) || [],
          client,
        );
        setAnswersList(
          submissions?.map((submission) => {
            const config = structuresConfig.find((config) => config.type === submission.structure?.type);
            const answersToParse = submission?.structure?.questionGroups;
            const parsedAnswers = parseAnswers(
              answersToParse,
              locale,
              config?.allIndex,
              config?.allTitle,
              config?.groupBy,
              filterByQuestionGroupKeys,
              category,
            );
            return checkIfNotEmpty(parsedAnswers) ? parsedAnswers : [];
          }) || [],
        );
      } else {
        const submission = await getSubmissionByExternalId(externalId, client, structureType);
        const answersToParse = submission?.structure.questionGroups;
        const parsedAnswers = parseAnswers(
          answersToParse,
          locale,
          allIndex,
          allTitle,
          groupByConfig,
          filterByQuestionGroupKeys,
          category,
        );
        const notEmpty = checkIfNotEmpty(parsedAnswers);
        if (notEmpty) {
          setAnswers(parsedAnswers);
        }
      }
      setLoading(false);
    };
    init().catch((err) => {
      handleError?.(err);
      setLoading(false);
    });
  }, [externalId]);

  return {
    answers,
    answersList,
    loading,
  };
};
